import { Component, inject, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import {
	ItInputComponent,
	ItTabContainerComponent,
	ItTabItemComponent,
	ItModalComponent,
	ItSelectComponent,
	ItTableComponent,
	ItButtonDirective,
	ItIconComponent,
} from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import type { Authority } from '../interfaces/authority';
import type { DocumentType } from '../interfaces/document-type';
import type { DocumentSubtype } from '../interfaces/document-subtype';
import type { DossierType } from '../interfaces/dossier-type';
import type { Phase } from '../interfaces/phase';

@Component({
	selector: 'app-admin-page',
	imports: [
		ItInputComponent,
		ItTabContainerComponent,
		ItTabItemComponent,
		ItModalComponent,
		ItSelectComponent,
		ItTableComponent,
		ItButtonDirective,
		ItIconComponent,
		FormsModule,
		TranslateModule,
	],
	templateUrl: './admin-page.component.html',
	styleUrl: './admin-page.component.scss',
})
export class AdminPageComponent implements OnInit {
	private iterlexService = inject(IterlexService);

	authorities: Authority[] = [];
	currentAuthority = '';
	authority = '';
	body = '';
	documentTypes: DocumentType[] = [];
	documentSubtypes: DocumentSubtype[] = [];
	currentDocumentSubtype!: DocumentSubtype;
	dossierTypes: DossierType[] = [];
	currentDossierType!: DossierType;
	phases: Phase[] = [];
	currentDossierPhases: Phase[] = [];
	ngOnInit(): void {
		this.iterlexService.getAuthorities().subscribe((authorities) => {
			this.authorities = authorities;
		});
	}
	load() {
		if (this.currentAuthority != '') {
			[this.authority, this.body] = this.currentAuthority.split('/');
			this.iterlexService
				.getDocumentTypes(
					new HttpParams().append('authority', this.authority),
				)
				.subscribe((documentTypes) => {
					this.documentTypes = documentTypes;
				});
			this.iterlexService
				.getDocumentSubtypes(
					new HttpParams().append('authority', this.authority),
				)
				.subscribe((documentSubtypes) => {
					this.documentSubtypes = documentSubtypes;
				});
			this.iterlexService
				.getDossierTypes(
					new HttpParams().append('authority', this.authority),
				)
				.subscribe((dossierTypes) => {
					this.dossierTypes = dossierTypes;
				});
			this.iterlexService
				.getPhases(this.authority, this.body)
				.subscribe((phases) => {
					this.phases = phases;
				});
		}
	}
	loadDossierPhases() {
		this.currentDossierPhases = [];
		this.iterlexService
			.getPhases(this.authority, this.body, this.currentDossierType.id)
			.subscribe((currentDossierPhases) => {
				this.currentDossierPhases = currentDossierPhases;
			});
	}
	onCreateSubtypesSubmit(form: NgForm) {
		if (form.valid) {
			this.iterlexService
				.createDocumentSubtype(
					this.authority,
					form.value.documentType,
					form.value.id,
					form.value.labelITA,
					form.value.labelDEU,
					form.value.order,
				)
				.subscribe(() => {
					this.load();
				});
		}
	}
	onEditSubtypesSubmit(form: NgForm) {
		if (form.valid) {
			this.iterlexService
				.editDocumentSubtype(
					this.authority,
					form.value.documentType,
					form.value.id,
					this.currentDocumentSubtype.id,
					form.value.labelITA,
					form.value.labelDEU,
					form.value.order,
				)
				.subscribe(() => {
					this.load();
				});
		}
	}
	deleteSubtype() {
		this.iterlexService
			.deleteDocumentSubtype(
				this.authority,
				this.currentDocumentSubtype.documentType,
				this.currentDocumentSubtype.id,
			)
			.subscribe(() => {
				this.load();
			});
	}
	addPhaseToDossierType(form: NgForm) {
		if (form.valid) {
			this.iterlexService
				.addPhaseToDossierType(
					this.authority,
					this.body,
					this.currentDossierType.id,
					form.value.phase,
					this.currentDossierPhases.length,
				)
				.subscribe(() => {
					this.loadDossierPhases();
				});
		}
	}
	orderPhase(index: number, change: number) {
		this.iterlexService
			.editPhaseInDossierType(
				this.authority,
				this.body,
				this.currentDossierType.id,
				this.currentDossierPhases[index].id,
				this.currentDossierPhases[index].order + change,
			)
			.subscribe(() => {
				this.iterlexService
					.editPhaseInDossierType(
						this.authority,
						this.body,
						this.currentDossierType.id,
						this.currentDossierPhases[index + change].id,
						this.currentDossierPhases[index + change].order -
							change,
					)
					.subscribe(() => {
						this.loadDossierPhases();
					});
			});
	}
	deletePhaseFromDossierType(phaseName: string) {
		this.iterlexService
			.deletePhaseFromDossierType(
				this.authority,
				this.body,
				this.currentDossierType.id,
				phaseName,
			)
			.subscribe(() => {
				this.loadDossierPhases();
			});
	}
}
